import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputComponent } from '../../../sale/components/form-field/form-input.component';
import { CustomerFormGroup } from '../../interfaces/customer';
import { FormsAddressComponent } from '../forms-address/forms-address.component';
import { FormsEmploymentHistoryComponent } from '../forms-employment-history/forms-employment-history.component';
import { FormArray, ReactiveFormsModule } from '@angular/forms';
import { EmploymentHistoryFormGroup } from '../../interfaces/employment-history';
import { AddressFormGroup } from '../../interfaces/address';
import { FormDatepickerComponent } from '../../../sale/components/form-datepicker/form-datepicker.component';

@Component({
    selector: 'app-forms-customer',
    standalone: true,
    imports: [CommonModule, FormsAddressComponent, FormsEmploymentHistoryComponent, ReactiveFormsModule, FormInputComponent, FormDatepickerComponent],
    templateUrl: './forms-customer.component.html',
    styleUrl: './forms-customer.component.scss',
})
export class FormsCustomerComponent {
    @Input() public formGroup: CustomerFormGroup | undefined;

    public get addresses(): FormArray<AddressFormGroup> {
        return this.formGroup?.get('addresses') as FormArray<AddressFormGroup>;
    }

    public get employmentHistories(): FormArray<EmploymentHistoryFormGroup> {
        return this.formGroup?.get('employment_histories') as FormArray<EmploymentHistoryFormGroup>;
    }
}
